import React from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton } from '@lux/wardrobe-lib'
import './DialogDuplicate.scss'

const DialogDuplicate = (props: {
    dialogVisible: boolean
    onSave: (confirm: boolean) => void
    onHide: () => void
}) => {
    const { dialogVisible, onSave, onHide } = props

    const componentClass = 'smart-modals-dialog-duplicate'

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}-buttons`}>
                <LuxButton
                    onClick={() => onSave(false)}
                    text={intl.formatMessage({
                        id: `generic.no`,
                        defaultMessage: 'No',
                    })}
                />
                <LuxButton
                    onClick={() => onSave(true)}
                    text={intl.formatMessage({
                        id: `generic.yes`,
                        defaultMessage: 'Yes',
                    })}
                />
            </div>
        )
    }

    return (
        <Dialog
            header={intl.formatMessage({
                id: 'modals.dialog.duplicate.title.duplicate',
                defaultMessage: 'duplicate',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}-description`}>
                {intl.formatMessage({
                    id: `modals.dialog.duplicate.description`,
                    defaultMessage: 'duplicate',
                })}
            </div>
        </Dialog>
    )
}

export default DialogDuplicate
